<template>
  <svg
    viewBox="0 0 32 32"
    xmlns="http://www.w3.org/2000/svg">
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M16.335 29.67C23.6997 29.67 29.67 23.6997 29.67 16.335C29.67 8.97028 23.6997 3 16.335 3C8.97028 3 3 8.97028 3 16.335C3 23.6997 8.97028 29.67 16.335 29.67ZM26.7067 16.335C26.7067 22.0631 22.0631 26.7067 16.335 26.7067C10.6069 26.7067 5.96333 22.0631 5.96333 16.335C5.96333 10.6069 10.6069 5.96333 16.335 5.96333C22.0631 5.96333 26.7067 10.6069 26.7067 16.335ZM16.5 10C15.6716 10 15 10.6716 15 11.5V22H18V11.5C18 10.6716 17.3284 10 16.5 10ZM11.5 12C10.6716 12 10 12.6716 10 13.5V22H13V13.5C13 12.6716 12.3284 12 11.5 12ZM20 18.5C20 17.6716 20.6716 17 21.5 17C22.3284 17 23 17.6716 23 18.5V22H20V18.5Z"
      fill="currentColor"/>
  </svg>
</template>
